import React, { useState } from "react";
import MotivationalMessage from "./MotivationalMessage";
const apiUrl = process.env.REACT_APP_END_POINT
import axios from 'axios';
import { useNavigate } from 'react-router';
import styled from "styled-components";

const HeartfeltPoem = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [theme, setTheme] = useState("");
  const [style, setStyle] = useState("");
  const [promptInput, setPromptInput] = useState('');
  const navigate = useNavigate();

  const handleGeneratePoem = async () => {

    // Validate inputs
    if (!promptInput || !theme || !style) {
      setError("All fields are required!");
      return;
    }

    if (window.gtag) {
      window.gtag('event', 'click', {
        event_category: 'generate',
        event_label: 'poem',
      });
    }

    setLoading(true);
    setError(""); 
    // Placeholder for API integration
      const userData = {
        prompt: promptInput,  // Text entered by user
        theme: theme,   // Tone selected by user
        style: style,  // Recipient entered by user (for personalized messages)
      };

    try {
      const response = await axios.post(`${apiUrl}/generatePoem`, userData);
      const { id } = response.data;
      
      // Redirect user to the page where the message will be displayed
      navigate(`/poem/${id}`);
    } catch (error) {
      setError("An error occurred while generating the message. Please try again.");
      console.error('Error generating message:', error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="feature-container">
    <MotivationalMessage text="Transform your feelings into beautiful verses. Share your poetic creations effortlessly!" />

      <textarea
        placeholder="Enter keywords or ideas for the poem..."
        rows="4"
        className="input-box"
        value={promptInput}
        onChange={(e) => setPromptInput(e.target.value)}
      ></textarea>

      <h3 className="section-heading">Select a Theme</h3>
      <div className="button-group">
        {["Love", "Friendship", "Nostalgia"].map((item) => (
          <button
            key={item}
            onClick={() => setTheme(item)}
            className={`rounded-button ${theme === item ? "active" : ""}`}
          >
            {item}
          </button>
        ))}
      </div>

      <h3 className="section-heading">Select a Style</h3>
      <div className="button-group">
        {["Romantic", "Classic", "Modern"].map((item) => (
          <button
            key={item}
            onClick={() => setStyle(item)}
            className={`rounded-button ${style === item ? "active" : ""}`}
          >
            {item}
          </button>
        ))}
      </div>

      {error && <ErrorMessage>{error}</ErrorMessage>}
      <GenerateButton onClick={handleGeneratePoem} disabled={loading}>
        {loading ? <Spinner /> : "Generate Poem"}
      </GenerateButton>
    </div>
  );
};

export default HeartfeltPoem;

const GenerateButton = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  width: 100%;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: 10px;
`;

const Spinner = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  display: inline-block;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
